import { Searchbar } from "#common";

function Filters({ keyword, setKeyword }) {
  return (
    <div className="px-6 ">
      <Searchbar
        clear={() => setKeyword("")}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
      />
    </div>
  );
}
export default Filters;
